<button mat-button type="button" class="bulkbar-cancel search-header-action-btn" *ngIf="backActionVisible" (click)="cancel()">Cancel</button>

<!-- STG/legacy visual order (float:right): report group, status, image, release, tag, download. Do not reorder. -->
<button class="bulkbar-action" mat-icon-button *ngIf="projectId && isClearanceUser && !readOnly && anyItemSelected()"
  (click)="initializeModal('modal-groupName')" matTooltip="report group" matTooltipPosition="below">
  <mat-icon>dns</mat-icon>
</button>

<button class="bulkbar-action" mat-icon-button *ngIf="!readOnly && enableStatusUpdateBatch()" (click)="initializeModal('modal-status')"
  matTooltip="change status" matTooltipPosition="below">
  <mat-icon>assignment_turned_in</mat-icon>
</button>

<button class="bulkbar-action" mat-icon-button *ngIf="!readOnly && anyItemSelected()" (click)="initializeModal('modal-image')"
  matTooltip="upload image" matTooltipPosition="below">
  <mat-icon>image</mat-icon>
</button>

<button class="bulkbar-action" mat-icon-button *ngIf="!readOnly && anyItemSelected()" (click)="initializeModal('modal-release')"
  matTooltip="upload release" matTooltipPosition="below">
  <mat-icon>attach_file</mat-icon>
</button>

<button class="bulkbar-action" mat-icon-button *ngIf="!readOnly && anyItemSelected()" (click)="tagsCanBeEdited && initializeModal('modal-tag')"
  [ngClass]="{'disabled': !tagsCanBeEdited}" matTooltip="add tag" matTooltipPosition="below">
  <mat-icon>local_offer</mat-icon>
</button>

<button class="bulkbar-action" mat-icon-button *ngIf="downloadButtonVisible && anyItemSelected()" (click)="downloadImages()"
  matTooltip="download attachments for selected items" matTooltipPosition="below">
  <mat-icon>download</mat-icon>
</button>
